(function (window) {
  function qar(cents) {
    var n = Math.round(Number(cents) || 0) / 100;
    if (!isFinite(n)) n = 0;
    var parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'QAR ' + parts.join('.');
  }

  function paint() {
    document.querySelectorAll('[data-qar-cents]').forEach(function (el) {
      el.textContent = qar(el.getAttribute('data-qar-cents'));
    });
    document.querySelectorAll('[data-qar-split]').forEach(function (el) {
      var cents = Number(el.getAttribute('data-qar-split') || 0);
      el.textContent = '4 x ' + qar(cents / 4);
    });
    document.querySelectorAll('[data-qar-emi]').forEach(function (el) {
      var cents = Number(el.getAttribute('data-qar-emi') || 0);
      el.textContent = qar(cents / 12);
    });
  }

  window.tbxQar = qar;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
})(window);
